import { SET_ADMIN_DASHBOARD_METRICS, SET_ADMIN_DASHBOARD_LOADING, SET_DASHBOARD_USERS, SET_DASHBOARD_USERS_LOADING } from './actions'

const initialState = {
  adminDashboardMetrics: {},
  loading: false,
  dashboardUsers: {
    list: [],
    totalCount: 0,
    currentPage: 0,
    totalPages: 0,
  },
  usersLoading: false,
}

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADMIN_DASHBOARD_LOADING:
      return {
        ...state,
        loading: action.data,
      }
    case SET_ADMIN_DASHBOARD_METRICS:
      return {
        ...state,
        adminDashboardMetrics: action.data,
        loading: false,
      }
    case SET_DASHBOARD_USERS_LOADING:
      return {
        ...state,
        usersLoading: action.data,
      }
    case SET_DASHBOARD_USERS:
      return {
        ...state,
        dashboardUsers: action.data,
        usersLoading: false,
      }
    default:
      return state
  }
}

export default adminDashboardReducer
